<app-state-view class="results-listing" [state]="state">
  <loading-state>
    <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
  </loading-state>
  <empty-state>
    <div class="results-listing__placeholder">
      <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
      <div class="results-listing__placeholder-message">Please enter a search query to perform a search.</div>
    </div>
  </empty-state>
  <error-state>
    <div class="results-listing__placeholder results-listing__placeholder--error">
      <mat-icon class="results-listing__placeholder-icon">warning</mat-icon>
      <div class="results-listing__placeholder-message">
        {{ errorMessage || 'An error occurred performing the search. Please try again later.' }}
      </div>
    </div>
  </error-state>
  <content-state>
    <div class="results-listing__container">
      <div class="results-listing__filter-bar">
        <button #flightSchoolPopoverAnchor="satPopoverAnchor" type="button" class="results-listing__filter"
                [satPopoverAnchorFor]="flightSchoolFiltersPopover" (click)="flightSchoolFiltersPopover.toggle()"
                [class.results-listing__filter--active]="flightSchoolPopoverAnchor.isPopoverOpen()">
          Flight School Filters
          <mat-icon class="results-listing__filter-arrow">keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <div #flightSchoolListEl *ngIf="flightSchools && flightSchools.length > 0; else placeholder" class="results-listing__list">
        <a class="flight-school-card"
           #flightSchoolEl *ngFor="let flightSchool of flightSchools"
           [class.flight-school-card--active]="flightSchool === activeFlightSchool"
           [routerLink]="['/business', flightSchool.businessId]"
           (click)="onFlightSchoolSelected()"
           (mouseenter)="onFlightSchoolHover(flightSchool, true)"
           (mouseleave)="onFlightSchoolHover(flightSchool, false)">
          <div class="flight-school-card__type-row">
            <span class="flight-school-card__type">{{ flightSchool.classifications && flightSchool.classifications.length ? flightSchool.classifications.join(' · ') : 'Flight School' }}</span>
            <span class="flight-school-card__flag" *ngIf="flightSchool.vaApproved">VA Approved</span>
          </div>
          <div class="flight-school-card__main">
            <div class="flight-school-card__content">
              <h2 class="flight-school-card__name">{{ flightSchool.name }}</h2>
              <div class="flight-school-card__body">
                <div class="flight-school-card__text" *ngIf="flightSchool.airportName || flightSchool.airportIdent">
                  <ng-container *ngIf="flightSchool.airportName">{{ flightSchool.airportName }}</ng-container><ng-container *ngIf="flightSchool.airportName && flightSchool.airportIdent"> - </ng-container><ng-container *ngIf="flightSchool.airportIdent">({{ flightSchool.airportIdent }})</ng-container>
                </div>
                <div class="flight-school-card__text" *ngIf="flightSchool.city || flightSchool.stateProvince">
                  {{ flightSchool.city }}<ng-container *ngIf="flightSchool.city && flightSchool.stateProvince">, </ng-container>{{ flightSchool.stateProvince }}
                </div>
                <div class="flight-school-card__text flight-school-card__detail" *ngIf="flightSchool.collegeName">
                  {{ flightSchool.collegeName }}
                </div>
                <div class="flight-school-card__text flight-school-card__detail"
                     *ngIf="flightSchool.instructorFull != null || flightSchool.instructorPart != null">
                  <span *ngIf="flightSchool.instructorFull != null">{{ flightSchool.instructorFull }} full-time</span>
                  <span *ngIf="flightSchool.instructorFull != null && flightSchool.instructorPart != null"> &middot; </span>
                  <span *ngIf="flightSchool.instructorPart != null">{{ flightSchool.instructorPart }} part-time</span>
                  instructors
                </div>
              </div>
            </div>
            <div class="flight-school-card__photo" *ngIf="flightSchool.thumbnailPhotoPath">
              <img class="flight-school-card__image" [src]="flightSchool.thumbnailPhotoPath" alt="" />
            </div>
          </div>
        </a>
      </div>
      <mat-paginator
        *ngIf="flightSchools && flightSchools.length > 0"
        class="results-listing__pagination"
        [pageIndex]="pageIndex"
        [length]="totalFlightSchools"
        [pageSize]="pageSize"
        (page)="onPageChanged($event)">
      </mat-paginator>
    </div>
  </content-state>
</app-state-view>

<ng-template #placeholder>
  <div class="results-listing__placeholder">
    <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
    <div class="results-listing__placeholder-message">
      No results found matching your search criteria. Try reducing the number of filters used in the search.
    </div>
  </div>
</ng-template>


<sat-popover #flightSchoolFiltersPopover horizontalAlign="start" verticalAlign="below" hasBackdrop>
  <div class="results-listing__popover">
    <app-flight-school-finder-filter-list #flightSchoolFilters [query]="query" [compact]="true"
                                          (filtersChange)="onFiltersChanged()">
    </app-flight-school-finder-filter-list>
  </div>
</sat-popover>
